<template>
  <div class="space-medium bg-white">
    <div class="container">
      <img src="https://media.allaboutwedding.com/media-import/cover/3475-ad-landing.png" class="img-fluid">
    </div>
  </div>
</template>
<script>
export default {
  name: "LandingAdv",
  props: {
    msg: String
  }
};
</script>
